import {
  DropDownListOptionType,
  FontWeightType,
} from "types/common/CommonType";

export interface FontDataType {
  /** 폰트를 찾아가는 키값 */
  key: string;
  /** 폰트페이스명으로 사용되는 값 */
  name: string;
  /** 폰트 굵기 종류 */
  weights: FontWeightType[];
  /** 선택시 기본으로 적용될 폰트 굵기 */
  defaultWeight: FontWeightType;
  /** 언어 */
  lang: string[];
  /** 해당 폰트 파일 확장자 */
  extension: "otf" | "ttf";
}
export const FONT_DATA: FontDataType[] = [
  {
    key: "Archivo",
    name: "Archivo",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Barlow",
    name: "Barlow",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "FiraSans",
    name: "Fira Sans",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "FrankRuhlLibre",
    name: "Frank Ruhl Libre",
    weights: [
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Medium",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Freesentation",
    name: "Freesentation",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "GmarketSans",
    name: "GmarketSans",
    weights: ["Light", "Medium", "Bold"],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "GoormSans",
    name: "goorm Sans",
    weights: ["Regular", "Medium", "Bold"],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "GowunBatang",
    name: "Gowun Batang",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Heebo",
    name: "Heebo",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Hind",
    name: "Hind",
    weights: ["Light", "Regular", "Medium", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "HindSiliguri",
    name: "Hind Siliguri",
    weights: ["Light", "Regular", "Medium", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Inter",
    name: "Inter",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Karla",
    name: "Karla",
    weights: [
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "KoPubBatang",
    name: "KoPubBatang_Pro",
    weights: ["Light", "Medium", "Bold"],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "KoPubDotum",
    name: "KoPubDotum_Pro",
    weights: ["Light", "Medium", "Bold"],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "LaundryGothic",
    name: "LaundryGothic",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Lora",
    name: "Lora",
    weights: ["Regular", "Medium", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "MangoDdobak",
    name: "Mango Ddobak",
    weights: ["Light", "Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Manrope",
    name: "Manrope",
    weights: [
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "MaruBuri",
    name: "MaruBuri",
    weights: ["ExtraLight", "Light", "Regular", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Montserrat",
    name: "Montserrat",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "NanumGothic",
    name: "Nanum Gothic",
    weights: ["Light", "Regular", "Bold", "ExtraBold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "NanumMyeongjo",
    name: "Nanum Myeongjo",
    weights: ["Regular", "Bold", "ExtraBold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "NanumBarunGothic",
    name: "Nanum Barun Gothic",
    weights: ["UltraLight", "Light", "Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "NanumSquare",
    name: "NanumSquare",
    weights: ["Light", "Regular", "Bold", "ExtraBold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "NotoSansKR",
    name: "Noto Sans KR",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "NotoSerif",
    name: "Noto Serif",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "OpenSans",
    name: "Open Sans",
    weights: ["Light", "Regular", "Medium", "SemiBold", "Bold", "ExtraBold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "PlayfairDisplay",
    name: "Playfair Display",
    weights: ["Regular", "Medium", "SemiBold", "Bold", "ExtraBold", "Black"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Poppins",
    name: "Poppins",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Pretendard",
    name: "Pretendard",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "PTSerif",
    name: "PT Serif",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Quicksand",
    name: "Quicksand",
    weights: ["Light", "Regular", "Medium", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Roboto",
    name: "Roboto",
    weights: ["Thin", "Light", "Regular", "Medium", "Bold", "Black"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "RobotoSlab",
    name: "Roboto Slab",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "SCoreDream",
    name: "S-Core Dream",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "SBAggro",
    name: "SB Aggro",
    weights: ["Light", "Medium", "Bold"],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "SpoqaHanSansNeo",
    name: "Spoqa Han Sans Neo",
    weights: ["Thin", "Light", "Regular", "Medium", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "SunBatang",
    name: "SunBatang",
    weights: ["Light", "Medium", "Bold"],
    defaultWeight: "Medium",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "IBMPlexSansKR",
    name: "IBM Plex Sans KR",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "AbrilFatface",
    name: "Abril Fatface",
    weights: ["Regular"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Arial",
    name: "Arial",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "BarlowCondensed",
    name: "Barlow Condensed",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Bitter",
    name: "Bitter",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "BookendBatang",
    name: "Bookend Batang",
    weights: ["Regular", "SemiBold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "BookkGothic",
    name: "Bookk Gothic",
    weights: ["Light", "Bold"],
    defaultWeight: "Light",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "BookkMyungjo",
    name: "Bookk Myungjo",
    weights: ["Light", "Bold"],
    defaultWeight: "Light",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "BritannicBold",
    name: "Britannic Bold",
    weights: ["Bold"],
    defaultWeight: "Bold",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "CenturyGothic",
    name: "Century Gothic",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "DelaGothicOne",
    name: "Dela Gothic One",
    weights: ["Regular"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "GangwonEduAll",
    name: "GangwonEduAll",
    weights: ["Light", "Bold"],
    defaultWeight: "Light",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Garet",
    name: "Garet",
    weights: ["Book", "Heavy"],
    defaultWeight: "Book",
    lang: ["en"],
    extension: "otf",
  },
  {
    key: "GothicA1",
    name: "Gothic A1",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "GyeonggiBatang",
    name: "GyeonggiBatang",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Hahmlet",
    name: "Hahmlet",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "HancomMalangMalang",
    name: "Hancom MalangMalang",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "JosefinSans",
    name: "Josefin Sans",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Kanit",
    name: "Kanit",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "KimjungchulGothic",
    name: "Kim jung chul Gothic",
    weights: ["Light", "Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "KimjungchulMyungjo",
    name: "Kim jung chul Myungjo",
    weights: ["Light", "Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "KingsCaslonTrial",
    name: "Kings Caslon Trial",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Lato",
    name: "Lato",
    weights: ["Thin", "Light", "Regular", "Bold", "Black"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "LibreBaskerville",
    name: "Libre Baskerville",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "LibreCaslonText",
    name: "Libre Caslon Text",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "LINESeedSans",
    name: "LINE Seed Sans",
    weights: ["Thin", "Regular", "Bold", "ExtraBold", "Heavy"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "LINESeedSansKR",
    name: "LINE Seed Sans KR",
    weights: ["Thin", "Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "LucidaBright",
    name: "Lucida Bright",
    weights: ["DemiBold"],
    defaultWeight: "DemiBold",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Merriweather",
    name: "Merriweather",
    weights: ["Light", "Regular", "Bold", "Black"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "NEXONLv2Gothic",
    name: "NEXON Lv2 Gothic",
    weights: ["Light", "Regular", "Medium", "Bold"],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Nunito",
    name: "Nunito",
    weights: [
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Oswald",
    name: "Oswald",
    weights: ["ExtraLight", "Light", "Regular", "Medium", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Paperlogy",
    name: "Paperlogy",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "Prata",
    name: "Prata",
    weights: ["Regular"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Raleway",
    name: "Raleway",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
    ],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "RobotoMono",
    name: "Roboto Mono",
    weights: ["Thin", "Light", "Regular", "Medium", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "Rockwell",
    name: "Rockwell",
    weights: ["Regular", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "SpaceGrotesk",
    name: "Space Grotesk",
    weights: ["Light", "Regular", "Medium", "SemiBold", "Bold"],
    defaultWeight: "Regular",
    lang: ["en"],
    extension: "ttf",
  },
  {
    key: "SUIT",
    name: "SUIT",
    weights: [
      "Thin",
      "ExtraLight",
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Heavy",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "SUITE",
    name: "SUITE",
    weights: [
      "Light",
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Heavy",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
  {
    key: "WantedSans",
    name: "Wanted Sans",
    weights: [
      "Regular",
      "Medium",
      "SemiBold",
      "Bold",
      "ExtraBold",
      "Black",
      "ExtraBlack",
    ],
    defaultWeight: "Regular",
    lang: ["ko", "en"],
    extension: "ttf",
  },
];

export const FONT_WEIGHT: {
  [key in FontWeightType]: number;
} = {
  Thin: 100,
  ExtraLight: 200,
  UltraLight: 200,
  Light: 300,
  Book: 300,
  Normal: 400,
  Regular: 400,
  Medium: 500,
  SemiBold: 600,
  Bold: 700,
  DemiBold: 700,
  ExtraBold: 800,
  UltraBold: 800,
  Heavy: 850,
  Black: 900,
  ExtraBlack: 950,
};
